import React, {useEffect, useRef, useState} from 'react';
import "./OnStore.scss";
import SimpleLineIcon from "react-simple-line-icons";
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import {Nav} from "../../Components";
import {CatData, StoreData} from "./StoreServices";
import {useHistory, useLocation} from "react-router-dom";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'
import {useSpeech,useImageLoaded} from "../../hooks";



function StoreCard({item}) {




    const history = useHistory();

    const gotToDetail= merchant => history.push(`/store-detail/${item.uid}`,{merchant})

    return(
        <div key={item.uid} className="store-item" onClick={()=>gotToDetail(item)}>
            <div className="store-item-scat">
                <span>{item.categories[0] && item.categories[0].title}</span>
            </div>
            <div className="store-item-info">
                <span className="store-item-name">{item.name}</span>
                <span className="store-item-cat">{item.subtitle}</span>
            </div>
            <div className="store-item-img">
                <img src={item.thumbnail} alt=""/>
            </div>
        </div>
    )
}

function FeaturedCard({item}) {
    const history = useHistory();
    const gotToDetail= merchant => history.push(`/store-detail/${item.uid}`,{merchant})
    const [sourceLoaded, setSourceLoaded] = useState(null)

    // useEffect(() => {
    //     const img = new Image()
    //     img.src = item.image
    //     img.onload = () => setSourceLoaded(src)
    // }, [src])

    return(
        <div onClick={()=>gotToDetail(item)} className="feature_item" key={item.uid} style={{backgroundImage: `url(${item.image})`}}>
          <span>{item.name}</span>
        </div>
    )
}


function OnStore() {


    const speech = useSpeech();
    const MyRef = useRef(null);
    const location = useLocation()

    // if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    //     return null
    // }




    const params = {
        slidesPerView: 'auto',
        spaceBetween: 15,
        // rebuildOnUpdate : true,
        rtl:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const [preload,setPreload] = useState(true);
    const [failed,setFailed] = useState(false);
    const [search,setSearch] = useState("");

    const [cats,setCats] = useState([])
    const [originalList,setOriginalList] = useState([])
    const [list,setList] = useState([])
    const [currentCat,set_currentCat] = useState([])



    const updateSlider = () =>{
        MyRef.current.swiper.update();
    }

    const getStore = async () => {
        setPreload(true);
        let hasLocal = false;

        //get local
        let localMerchants = localStorage.getItem('merchants')
        let searchMall = localStorage.getItem('mallId');
        if(localMerchants){
            let parsedMerchants = JSON.parse(localMerchants)
            if(parsedMerchants.mall===searchMall){
                setPreload(false);
                setList(parsedMerchants.data);
                setOriginalList(parsedMerchants.data);
                hasLocal = true;
            }
        }


        //get server
        try{
            let response = await StoreData();
            let merchants = response.data.filter(merchant=>{
                return merchant.type=="merchant"
            })
            localStorage.setItem('merchants',JSON.stringify({mall:searchMall,data:merchants}))
             setPreload(false);
                // setList(merchants);
                // setOriginalList(merchants);
            // console.log("stores : ",merchants);
            if(hasLocal){
                setOriginalList(merchants);
                if(location.state){
                    console.log("CAT LINK : ",location.state.catLink)
                    selectInitCat(location.state.catLink,merchants)
                }
                console.log("has lovalll")
            }else {
                setList(merchants);
                setOriginalList(merchants);
                console.log("has serrverrr")
            }
            updateSlider();
        }catch (e) {
            setPreload(false);
            // console.log(e)
        }
    }

    const getCat = async () => {
        //get local
        let localCats = localStorage.getItem('cats')
        if(localCats) {
            let parsedCats = JSON.parse(localCats)
            setCats(parsedCats);
        }
        //get server
        try{
            let response = await CatData();
            let cats = response.data.filter(cat=>{
                return cat.type=="merchant"
            })
            // set for all
            const catsObj = {description: "", image: "https://test-loyalty-minio.darkube.app/loyalty-media/merchant/category/images/Cafe.jpg", mall_uid: cats[0].mall_uid, map_image: "https://s3.mobank.co/loyalty-media/merchant/category/map_images/Artboard_20hdpi.png", map_image_color: "ad6800", title: "همه", type: "merchant", uid: "007"}
            cats.push(catsObj)
            cats.reverse()
            localStorage.setItem('cats',JSON.stringify(cats))
            setCats(cats);
            // console.log("OnlineStoreSubCat  : ", cats)
        }catch (e) {
            // console.log(e)
        }
    }


    const searchList = (word)=>{
        if(word.length<1){setList(originalList)}
        if(word.length>2){
            let result = []
            originalList.forEach(item=>{
                try{
                    let add = null;
                    //check tags
                    item.tags.forEach(item=>{if(item.includes(word)){add =true}});
                    //check description,address,name,subtitle

                    let sub = item.subtitle?item.subtitle.includes(word):false;
                    let des = item.description?item.description.includes(word):false
                    let adr = item.address?item.address.includes(word):false
                    let na = item.name?item.name.includes(word):false

                    if(sub || des || adr || na){
                        add = true;
                    }

                    // console.log("D : ",item.subtitle.includes("کیک"),word)
                    // console.log("H : ",item.subtitle.includes(word),word)

                    //add to result
                    if(add){
                        result.push(item);
                    }
                    setList(result);

                }catch (e) {
                    // console.log(e)
                }
            })
        }
    }


    const selectCat =(cat)=>{
        console.log(cat)
        // return;
        set_currentCat(cat)
        // select all
        if(cat.uid ==="007"){setList(originalList);
            setSearch("");
        return;}

        console.log("originalList : ",originalList)
        let filteredList  =originalList.filter(item=>{
            return  item.categories.some(el => el.uid === cat.uid);
        });

        setSearch("");
        setList(filteredList);
    }

    const selectInitCat =(cat,list)=>{
        console.log(cat)
        // return;
        set_currentCat(cat)
        // select all
        if(cat.uid ==="007"){setList(originalList);
            setSearch("");
            return;}

        console.log("originalList : ",list)
        let filteredList  =list.filter(item=>{
            return  item.categories.some(el => el.uid === cat.uid);
        });

        setSearch("");
        setList(filteredList);
    }

    useEffect(()=>{
        if(location.state){
            console.log("CAT LINK : ",location.state.catLink)
            // setTimeout(()=>{
            //     selectCat(location.state.catLink)
            // },6000)
        }
    },[])

    useEffect(()=>{
        getStore().then();
        getCat().then();
    },[])

    useEffect(()=>{
        if(speech.length>1){
            setSearch(speech)
            searchList(speech)
        }
    },[speech])

    return(
        <div className="store-container">
            <div className="store-head">
            <div className="store-header">
                {/*<i className="fa fa-bars"></i>*/}
                <input
                    value={search}
                    onChange={(e)=>{
                        setSearch(e.target.value)
                        searchList(e.target.value)
                    }}
                    type="text" name="" id="" placeholder="دنبال چی میگردی..."/>
                <div>
                    <SimpleLineIcon name="magnifier" />
                </div>
            </div>
            <div className="store-categories">
                {/*OnlineStoreSubCat List*/}
                <div className="store-categories-list">
                    {cats.length>0?  <Swiper ref={MyRef}  {...params}>
                        {cats.map(cat=>{
                            return (
                                <div key={cat.uid}
                                     onClick={()=>{selectCat(cat)}}
                                     // style={{backgroundImage: `url(${cat.image})`}}
                                     className="store-categories-item">
                                    <span className={currentCat.uid===cat.uid?"cat_select":"cat_deselect"}>{cat.title}
                                    {/*<i className="fa fa-user"></i>*/}
                                    </span>
                                    <img src={cat.image}  alt="" style={{width:'100%'}}/>
                                </div>
                            )
                        })}
                    </Swiper>:null}
                </div>
            </div>
        </div>

            <div className="store-body">
                {/* OnStore List*/}
                {!preload?<div className="store-list" style={{paddingBottom:100}}>
                    {list.filter(l=>l.online_merchant).map(item=>{
                        if(item.is_featured){
                            return <FeaturedCard key={item.uid} item={item}/>;
                        }else {
                            return <StoreCard key={item.uid} item={item}/>;
                        }
                    })}
                </div>:<div className="customer-preLoading">
                    {!failed?<div className="customer-preloading-body">
                        <img src="/svg/pre.gif" alt=""/>
                    </div>:<div className="customer-failed-body">
                        <img src="/svg/failed.svg" alt=""/>
                        <span>اطلاعاتی موجود نیست</span>
                    </div>}
                </div>}
            </div>
            <Nav/>
        </div>
    )
}

export {OnStore};
